import styled from "styled-components";

export const ContainerOrdenes = styled.div`
  width: 100vw;
  height: 80vh;
  height: 80dvh;
  display: flex;
  justify-content: center;
`;
